import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import { pagedList, sortDirection } from "@/models/pagedList";
import { CustomerInfoModel } from "@/models/customerModels";
import { OfferProductModel, ShoppingOfferModel } from "@/models/offerModel";
import moment from "moment";
@Component({})
export default class offersFVList extends Vue {
    @Prop({ default: "Lista preventivi" })
    title: string;
    @Prop({ default: false })
    isLoading: boolean;

    @Prop({ default: true })
    selectable: boolean;

    @Prop({ default: false })
    showGoToCart: boolean;

    @Prop({ default: false })
    showFatturato: boolean;

    @Prop({ default: sortDirection.ASC })
    sortDirection: sortDirection;

    @Prop({ default: "" })
    sortField: string;

    @Prop({ default: true })
    enableSort: boolean;

    onSelect(customer: CustomerInfoModel) {
        if (this.selectable) this.$emit("selected", customer);
    }

    get colSpan(): number {
        return this.showFatturato ? 8 : 7;
    }
    @Prop({ default: () => new pagedList<CustomerInfoModel>() })
    pagedList: pagedList<CustomerInfoModel>;

    @Prop({ default: () => new Array<CustomerInfoModel>() })
    list: Array<CustomerInfoModel>;

    showOfferPanel: boolean = false;
    selectedOffer: ShoppingOfferModel = null;

    headClick(field: string) {
        this.$emit("sort", field);
    }
    getSortCss(field: string): string {
        if (field != this.sortField) return "fas fa-sort text-black-transparent-5";

        return this.sortDirection == sortDirection.ASC ? "fas fa-sort-up text-black" : "fas fa-sort-down text-black";
    }

    getProvincia(customer: CustomerInfoModel): string {
        if (customer.shippingAddresses == null || customer.shippingAddresses.length == 0) return "";
        return customer.shippingAddresses[0].region;
    }
    getDescription(customer: CustomerInfoModel): string {
        if (customer.type == "Company") return customer.company;
        return customer.lastName;
    }
    getDetailUrl(customer: CustomerInfoModel): string {
        return `/cart/offer/${customer.id}`;
    }
    get offers(): Array<CustomerInfoModel> {
        if (this.pagedList == null || this.pagedList.items == null) return this.list == null ? [] : this.list;
        return this.pagedList.items;
    }

    getRowPublicPrice(offer: ShoppingOfferModel) {
        if (offer && offer.products && offer.products.length) {
            const groupedBySku = new Map();

            offer.products.forEach((cartProduct) => {
                const sku = cartProduct.sku;

                if (groupedBySku.has(sku)) {
                    groupedBySku.get(sku).push(cartProduct);
                } else {
                    groupedBySku.set(sku, [cartProduct]);
                }
            });

            let result = 0;
            
            groupedBySku.forEach((productsArray: OfferProductModel[]) => {
                let totalQuantity = productsArray.reduce((sum, currentProduct) => sum + currentProduct.quantity, 0);
                result += totalQuantity * productsArray[0].publicPrice;
            });

            return result;
        }

        return 0;
    }

    getRowShoppingPrice(offer: ShoppingOfferModel) {
        if (offer && offer.products && offer.products.length) {
            const groupedBySku = new Map();

            offer.products.forEach((cartProduct) => {
                const sku = cartProduct.sku;

                if (groupedBySku.has(sku)) {
                    groupedBySku.get(sku).push(cartProduct);
                } else {
                    groupedBySku.set(sku, [cartProduct]);
                }
            });

            let result = 0;

            groupedBySku.forEach((productsArray: OfferProductModel[]) => {
                result += productsArray.reduce((sum, currentProduct) => sum + (currentProduct.rowNetTotal || 0), 0);
            });

            return result;
        }

        return 0;
    }

    onShowOfferPanel(offer: ShoppingOfferModel) {
        this.selectedOffer = JSON.parse(JSON.stringify(offer));
        this.showOfferPanel = true;
    }

    onCloseOfferPanel() {
        this.selectedOffer = null;
        this.showOfferPanel = false;
    }

    onDeleteOffer() {
        this.selectedOffer = null;
        this.showOfferPanel = false;

        this.$emit("onDeleteOffer");
    }

    onFetchList() {
        this.$emit("onFetchList");
    }

    checkValidity(offer: ShoppingOfferModel) {
        if (offer && offer.validTo) {
            let now = moment().startOf("day");
            return now <= moment(offer.validTo);
        }

        return false;
    }
}
